import moment from 'moment';
import { FiscalStartDate, FiscalEndDate } from '../helpers/config';

const fiscalStartDate = moment(FiscalStartDate).toDate();
const fiscalEndDate = moment(FiscalEndDate).toDate();

const lastWeekStart = moment()
  .subtract(1, 'weeks')
  .startOf('week')
  .toDate();
const lastWeekEnd = moment()
  .subtract(1, 'weeks')
  .endOf('week')
  .toDate();

const lastMonthStartDate = moment()
  .subtract(1, 'months')
  .startOf('month')
  .toDate();
const lastMonthEndDate = moment()
  .subtract(1, 'months')
  .endOf('month')
  .toDate();

export default [
  {
    label: 'Last Week',
    value: [lastWeekStart, lastWeekEnd]
  },
  {
    label: 'Last Month',
    value: [lastMonthStartDate, lastMonthEndDate]
  },
  {
    label: 'Calendar Year',
    value: [
      moment()
        .startOf('year')
        .toDate(),
      moment()
        .endOf('year')
        .toDate()
    ]
  },
  {
    label: 'Fiscal Year',
    value: [fiscalStartDate, fiscalEndDate]
  }
];
